import { IDealProduct } from 'store/field-options/types';

export enum EPayCycle {
  MONTH = 'month',
  DELIVERY = 'delivery',
}

export interface FormulasInterface {
  name: string;
  formula: string;
  description?: string;
  types?: string;
  isFavorite?: boolean;
}

export interface IDeal {
  id?: string;
  name: string;
  status: string;
  description?: string;

  customer?: string;
  region?: string;
  productLine?: string;

  payCycle: EPayCycle | null;
  payDelay: number | null;
  stdPayCycle: EPayCycle | null;
  stdPayDelay: number | null;
  probDefault: number | null;

  createdOn?: string;
  createdBy?: string;
  modifiedOn?: string;
  modifiedBy?: string;
  productName?: { name: string; selected: boolean }[];
  products?: IDealProduct[];
  formulas?: FormulasInterface[];

  // meta
  validationErrors?: IDealValidationErrors;
  isDirty?: boolean;
  offerType: string | null;
  otherCredit?: string | null;
  nonstandardRisks?: string[];
  margin_at_risk: number | null;
  volume: number | null;
}

export interface IDealDataSelector {
  id?: string;
  name: string;
  status: string;
  products?: IDealProduct[];
  customer?: string;
  dates?: { startDate: Date | string | undefined; endDate: Date | string | undefined }[];
  productName?: { name: string; selected: boolean }[];
  totalVolume?: string[];
  totalRevenue?: string[];
  totalNetback?: string[];
  totalMargin?: string[];
  totalMarginAtRisk?: string[];
  pricingFormulas?: string[];
  offerTypes?: string;
  headLine?: string[];
  contractBatna1?: string[];
  costToServeYield?: string[];
  totalSupplyCost?: string;
  reimbursedSupplyCost?: string[];
  variableSupplyCost?: string[];
  fixedSupplyCost?: string[];
  additionalInventory?: string[];
  additionalTransitDay?: (number | '-')[];
  modeOfTransport?: string[];
  incoTerm?: string[];
  otherSupplyItems?: string[];
  creditTerm?: string;
  credit?: string[];
  probabilityOfDefault?: string;
  exposure?: string[];
  otherCreditItems?: string;
  optionsValue?: string[];
  cap?: string;
  floor?: string;
  customerFlex?: string;
  pushVal?: string;
  pullVal?: string;
  extensions?: string;
  earlyTermination: string | undefined;
  priceSwitch?: string[];
  capDescriptions?: string[];
  floorDescriptions?: string[];
  customerFlexDescription?: string;
  pushDescription?: string[];
  pullDescription?: string[];
  extensionDescription?: string[];
  earlyTerminationDescription?: string;
  priceSwitchDescription?: string;
  nonstandardRisks?: string[];
  header?: string;
  sharpeRatio?: string[];
  contractContractWOOptions?: (string | string[])[];
}

export interface IDealValidationErrors {
  name: string | null;
  status: string | null;
}

export enum EDealField {
  CUSTOMER = 'customer',
  DESCRIPTION = 'description',
  NAME = 'name',
  PERIOD_END = 'periodEnd',
  PERIOD_START = 'periodStart',
  PRODUCT_LINE = 'productLine',
  PRODUCTS = 'products',
  REGION = 'region',
  SEASON = 'season',
  STATUS = 'status',
  PAY_CYCLE = 'payCycle',
  PAY_DELAY = 'payDelay',
  STANDARD_PAY_CYCLE = 'stdPayCycle',
  STANDARD_PAY_DELAY = 'stdPayDelay',
  PROBABILITY_OF_DEFAULT = 'probDefault',
  FORMULAS = 'formulas',
  NON_STANDARD_RISKS = 'nonstandardRisks',
  ADDITIONAL_CREDIT_REQUIRMENT = 'otherCredit',
  OFFER_TYPE = 'offerType',
}

export enum EPaymentTerm {
  STANDARD = 'standard',
  PROPOSED = 'proposed',
}

export enum ESearchFilter {
  ALL = 'all',
  MINE = 'mine',
}

export interface IDealState {
  loading: boolean;
  error?: Error | null;
  data: IDeal[];
  searchKeyword: string;
  searchFilter: ESearchFilter;
  statusFilter: string;
}

export const CREATE_DEAL_SUCCESS = 'CREATE_DEAL_SUCCESS';

export const GET_DEALS = 'GET_DEALS';
export const GET_DEALS_SUCCESS = 'GET_DEALS_SUCCESS';
export const GET_DEALS_FAIL = 'GET_DEALS_FAIL';

export const SAVE_DEAL = 'SAVE_DEAL';
export const SAVE_DEAL_SUCCESS = 'SAVE_DEAL_SUCCESS';
export const SAVE_DEAL_FAIL = 'SAVE_DEAL_FAIL';

export const DELETE_DEAL = 'DELETE_DEAL';
export const DELETE_DEAL_SUCCESS = 'DELETE_DEAL_SUCCESS';
export const DELETE_DEALS_SUCCESS = 'DELETE_DEALS_SUCCESS';
export const DELETE_DEAL_FAIL = 'DELETE_DEAL_FAIL';

export const SET_DEAL_SEARCH_FILTER = 'SET_DEAL_SEARCH_FILTER';
export const SET_DEAL_SEARCH_KEYWORD = 'SET_DEAL_SEARCH_KEYWORD';

export const SET_DEAL_SEARCH_STATUS_FILTER = 'SET_DEAL_SEARCH_STATUS_FILTER';
